__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "conf.app-front";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(710), __webpack_require__.e(761)]).then(() => (() => (__webpack_require__(88761))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(186), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "6.4.6", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(805), __webpack_require__.e(746), __webpack_require__.e(592), __webpack_require__.e(710), __webpack_require__.e(186), __webpack_require__.e(374)]).then(() => (() => (__webpack_require__(78592))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__(74353))))));
			register("i18next", "25.7.3", () => (__webpack_require__.e(635).then(() => (() => (__webpack_require__(72635))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "16.5.0", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(450), __webpack_require__.e(494)]).then(() => (() => (__webpack_require__(36494))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(16443);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};